import {
  CommonModule,
  isPlatformBrowser,
  NgClass,
  NgIf,
} from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';
import { ApiService } from '../../../services/api.service';
import { CardChipsComponent } from '../card/card-chips/card-chips.component';
import { SectionContainerComponent } from '../section-container/section-container.component';
import { SectionDescriptionComponent } from '../section-description/section-description.component';
import { SectionHeadingComponent } from '../section-heading/section-heading.component';
import { ArtifactCardComponent } from '../../utility/artifact-card/artifact-card.component';
import { CardSkeletonLoaderComponent } from '../../utility/card-skeleton-loader/card-skeleton-loader.component';
import { CategoryTypes } from '../../../models/category-types.model';
import { Dataset } from '../../../models/dataset.model';
import { routes } from '../../../constants/routes';
import { CouldntLoadDataComponent } from '../couldnt-load-data/couldnt-load-data.component';
import { NoRecordFoundComponent } from '../no-record-found/no-record-found.component';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { ApiErrorHandler } from '../../../models/api-error-handler.model';
import { ToasterService } from '../../../services/toaster.service';
import { redirectPrimarySVG } from '../../../constants/svg/redirectPrimarySvg';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-home-compute',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    SectionContainerComponent,
    SectionHeadingComponent,
    SectionDescriptionComponent,
    NgClass,
    NgIf,
    SafeHtmlPipe,
  ],
  templateUrl: './home-compute.component.html',
  styleUrl: './home-compute.component.scss',
})
export class HomeComputeComponent {
  readonly redirectPrimarySVG = redirectPrimarySVG;
  readonly routes = routes;
  readonly computeDetails = {
    name: 'Start with your Notebook',
    description:
      'High-performance GPU and CPU environments for machine learning research. Powered by',
  };

  openIndiaAI() {
    window.open('https://compute.indiaai.gov.in/login', '_blank');
  }

  handleLaunchComputeBtn() {
    window.open(
      `${environment.webUrl}${environment.webBaseHref}notebook/listing`,
      '_self',
    );
  }
}
